// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "public/css/" + chunkId + "." + {"2710":"f7afa03d321a4d2cf7c3","9329":"dac55a5d53916ec41dfa"}[chunkId] + ".css";
};